<script setup lang="ts">
const props = defineProps<{
	grayBg?: boolean
}>()

const swiper = useSwiper()
</script>

<template>
	<div class="swiper-nav">
		<button :data-hidden="swiper.isBeginning" class="swiper-nav__btn swiper-nav__btn--left" @click="swiper.slidePrev()">
			<GlobalIcon name="arrow-left" :height="20" />
		</button>
		<button :data-hidden="swiper.isEnd" class="swiper-nav__btn swiper-nav__btn--right" @click="swiper.slideNext()">
			<GlobalIcon name="arrow-right" :height="20" />
		</button>
		<div
			:data-hidden="swiper.isBeginning"
			class="swiper-nav__gradient swiper-nav__gradient--left"
			:class="{ 'swiper-nav__gradient--gray-left': props.grayBg }"></div>
		<div
			:data-hidden="swiper.isEnd"
			class="swiper-nav__gradient swiper-nav__gradient--right"
			:class="{ 'swiper-nav__gradient--gray-right': props.grayBg }"></div>
	</div>
</template>

<style lang="scss" scoped>
@import './SwiperNav';
</style>
